var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 36,
    viewBox: "0 0 58 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#14B497",
    d: "M.474 0H16.87c.261 0 .473.212.473.474v28.53a5.92 5.92 0 0 1-5.92 5.92H0V.474C0 .212.212 0 .474 0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.484 14.99v15.736c0 1.09-.265 1.914-.795 2.473-.53.558-1.203.838-2.018.838-.815 0-1.478-.286-1.987-.858-.51-.572-.765-1.39-.765-2.453V15.149c0-1.077.255-1.888.765-2.433.51-.545 1.172-.818 1.987-.818.815 0 1.488.273 2.018.818.53.545.795 1.303.795 2.273zM8.732 9.353c-.774 0-1.437-.233-1.987-.699-.55-.465-.826-1.124-.826-1.975 0-.772.282-1.407.846-1.906a2.877 2.877 0 0 1 1.967-.748c.72 0 1.359.226 1.916.679.557.452.836 1.11.836 1.975 0 .838-.272 1.493-.815 1.965-.544.473-1.19.709-1.937.709z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#676767",
    fillRule: "nonzero",
    d: "M43.01 18.715V35.22c0 .131-.106.237-.237.237h-4.112a.237.237 0 0 1-.237-.237V22.625c0-2.556-.342-4.34-1.027-5.351-.685-1.01-1.88-1.516-3.584-1.516-.952 0-1.825.217-2.619.651-.793.435-1.7 1.203-2.718 2.306V35.22c0 .131-.106.237-.237.237h-4.087a.237.237 0 0 1-.237-.237V12.636c0-.13.106-.237.237-.237h4.087c.13 0 .237.106.237.237v2.796c2.322-2.323 4.594-3.484 6.816-3.484 2.923 0 5.187 1.387 6.79 4.16 2.44-2.807 4.988-4.21 7.644-4.21 2.239 0 4.08.819 5.525 2.456 1.446 1.638 2.168 4.136 2.168 7.494V35.22c0 .131-.106.237-.237.237h-4.087a.237.237 0 0 1-.237-.237V21.798c0-1.922-.392-3.392-1.177-4.411-.786-1.02-1.913-1.53-3.384-1.53-1.887 0-3.65.953-5.287 2.858z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBar);
export default __webpack_public_path__ + "static/media/logo-bar.edae77993a9d30a84e924481ff45c351.svg";
export { ForwardRef as ReactComponent };